import { Component, EventEmitter, HostBinding, HostListener, Input, OnChanges, Output } from '@angular/core';
import { Settings } from '../../../../settings.class';
import { Utils } from '../../../../utils.class';

@Component({
    selector: 'app-date-indicator',
    templateUrl: './date-indicator.component.html',
    styleUrls: ['./date-indicator.component.scss'],
    standalone: false,
})
export class DateIndicatorComponent implements OnChanges {
    @Input()
    public fromDate: Date;

    @Input()
    public singleDate: Date;

    @Input()
    public toDate: Date;

    @Input()
    public print: boolean;

    @Input()
    public primaryWeekStart: Date;

    @Input()
    public primaryWeekEnd: Date;

    @Input()
    disableNext = false;

    @Input() @HostBinding('class.full-width') fullWith = false;

    @Output()
    public next = new EventEmitter<void>();

    @Output()
    public prev = new EventEmitter<void>();

    weekwidth = 0;
    weekright = 0;
    isMobile = false;

    ngOnChanges() {
        this.calculateWeekDimensions();
    }

    @HostListener('window:resize')
    onResize() {
        this.calculateWeekDimensions();
    }

    private calculateWeekDimensions() {
        this.isMobile = window.matchMedia('(max-width: 826px)').matches;
        if (this.toDate && this.primaryWeekStart && !this.isMobile) {
            const showMaxDays = 8 - Utils.dutchDayOfWeek(this.primaryWeekStart);
            const daysToLastVisibleDay = Math.ceil(
                (this.toDate.getTime() - this.primaryWeekStart.getTime()) / (1000 * 60 * 60 * 24)
            );

            this.weekwidth = this.fullWith ? null : Math.min(showMaxDays, daysToLastVisibleDay) * Settings.DAY_WIDTH;
            this.weekright = this.fullWith
                ? 0
                : (daysToLastVisibleDay - Math.min(showMaxDays, daysToLastVisibleDay)) * Settings.DAY_WIDTH;
        } else {
            this.weekwidth = 0;
            this.weekright = 0;
        }
    }
}
